"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.impactTypeUpdate = exports.impactTypeSuccess = exports.impactTypeSoftDeletedList = exports.impactTypeSoftDeleteRestore = exports.impactTypeSoftDelete = exports.impactTypeReset = exports.impactTypeListReset = exports.impactTypeGetPaletteList = exports.impactTypeGetList = exports.impactTypeFetch = exports.impactTypeError = exports.impactTypeDelete = exports.impactTypeBulkSoftDelete = exports.impactTypeBulkRestore = exports.impactTypeBulkHardDelete = exports.impactTypeAdd = void 0;
var _impactType = require("./impactType.constant");
// common success
var impactTypeSuccess = function impactTypeSuccess(actionType, data) {
  return {
    type: _impactType.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.impactTypeSuccess = impactTypeSuccess;
var impactTypeError = function impactTypeError(actionType, error) {
  return {
    type: _impactType.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * fetch impactType
 * @param payload
 * @returns api response
 * @description this function used to fetch impactType with id and year.
 */
exports.impactTypeError = impactTypeError;
var impactTypeGetList = function impactTypeGetList(data) {
  return {
    type: _impactType.actionTypes.LIST,
    payload: data
  };
};

/**
 * fetch impactType
 * @param payload
 * @returns api response
 * @description this function used to fetch impactType with id and year.
 */
exports.impactTypeGetList = impactTypeGetList;
var impactTypeGetPaletteList = function impactTypeGetPaletteList(data) {
  return {
    type: _impactType.actionTypes.PALETTE_LIST,
    payload: data
  };
};

/**
 * fetch impactType
 * @param payload
 * @returns api response
 * @description this function used to fetch impactType with id and year.
 */
exports.impactTypeGetPaletteList = impactTypeGetPaletteList;
var impactTypeFetch = function impactTypeFetch(data) {
  return {
    type: _impactType.actionTypes.FETCH,
    payload: data
  };
};

/**
 * Add
 * @param payload
 * @returns api response
 * @description this function used to add impactType list.
 */
exports.impactTypeFetch = impactTypeFetch;
var impactTypeAdd = function impactTypeAdd(data) {
  return {
    type: _impactType.actionTypes.ADD,
    payload: data
  };
};

/**
 * impactType update
 * @param payload
 * @returns api response
 * @description this function used to update impactType given inputs.
 */
exports.impactTypeAdd = impactTypeAdd;
var impactTypeUpdate = function impactTypeUpdate(data) {
  return {
    type: _impactType.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * impactType delete
 * @param payload
 * @returns api response
 * @description this function used to delete impactType of given params.
 */
exports.impactTypeUpdate = impactTypeUpdate;
var impactTypeDelete = function impactTypeDelete(data) {
  return {
    type: _impactType.actionTypes.DELETE,
    payload: data
  };
};

/**
 * Reset data
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.impactTypeDelete = impactTypeDelete;
var impactTypeReset = function impactTypeReset() {
  return {
    type: _impactType.actionTypes.RESET
  };
};

/**
 * Reset data
 * @param payload
 * @returns api response
 * @description this function used to reset data.
 */
exports.impactTypeReset = impactTypeReset;
var impactTypeListReset = function impactTypeListReset() {
  return {
    type: _impactType.actionTypes.RESET_LIST
  };
};

/**
 * soft delete
 * @param payload
 * @returns api response
 * @description this function used to soft delete.
 */
exports.impactTypeListReset = impactTypeListReset;
var impactTypeSoftDelete = function impactTypeSoftDelete(data) {
  return {
    type: _impactType.actionTypes.SOFT_DELETE,
    payload: data
  };
};

/**
 * soft delete restore
 * @param payload
 * @returns api response
 * @description this function used to soft delete restore.
 */
exports.impactTypeSoftDelete = impactTypeSoftDelete;
var impactTypeSoftDeleteRestore = function impactTypeSoftDeleteRestore(data) {
  return {
    type: _impactType.actionTypes.SOFT_DELETE_RESTORE,
    payload: data
  };
};

/**
 * soft deleted list
 * @param payload
 * @returns api response
 * @description this function used to soft deleted list.
 */
exports.impactTypeSoftDeleteRestore = impactTypeSoftDeleteRestore;
var impactTypeSoftDeletedList = function impactTypeSoftDeletedList(data) {
  return {
    type: _impactType.actionTypes.SOFT_DELETED_LIST,
    payload: data
  };
};

/**
 * bulk soft delete
 * @param payload
 * @returns api response
 * @description this function used to bulk soft delete.
 */
exports.impactTypeSoftDeletedList = impactTypeSoftDeletedList;
var impactTypeBulkSoftDelete = function impactTypeBulkSoftDelete(data) {
  return {
    type: _impactType.actionTypes.BULK_SOFT_DELETE,
    payload: data
  };
};

/**
 * bulk restore
 * @param payload
 * @returns api response
 * @description this function used to bulk restore.
 */
exports.impactTypeBulkSoftDelete = impactTypeBulkSoftDelete;
var impactTypeBulkRestore = function impactTypeBulkRestore(data) {
  return {
    type: _impactType.actionTypes.BULK_RESTORE,
    payload: data
  };
};

/**
 * bulk hard delete
 * @param payload
 * @returns api response
 * @description this function used to bulk hard delete.
 */
exports.impactTypeBulkRestore = impactTypeBulkRestore;
var impactTypeBulkHardDelete = function impactTypeBulkHardDelete(data) {
  return {
    type: _impactType.actionTypes.BULK_HARD_DELETE,
    payload: data
  };
};
exports.impactTypeBulkHardDelete = impactTypeBulkHardDelete;